export default __webpack_public_path__ + "static/media/aboutUs2Small.8c2678ff.webp";